import { createAction, props } from '@ngrx/store';

export const HEADER_SPACER_ACTION = '[Header Spacer] set header spacer';

export const setHeaderSpacer = createAction(
  HEADER_SPACER_ACTION,
  props<{ headerSpacer: string }>()
);
